export const TABLE_CONSTANTS = {
  DEFAULT_PAGE_SIZE: 10,
  MIN_HEADER_HEIGHT: 48.5,

  DEFAULT_GLOBAL_FILTER: '',
  DEFAULT_PAGINATION_INDEX: 0,
  DEFAULT_IS_GROUP_BY_PARENT: false,

  EXCLUDED_COLUMNS: ['created_at', 'updated_at'],
  DEFAULT_ROW_SPAN: 12,
} as const;

export const PAGE_SIZE_OPTIONS = [10, 20, 50] as const;
